// Contents
export const FORM_TYPES = [
  'card',
  'listicle',
  'article',
  'article-cta',
  'video',
  'freeform'
]
export const contentTypeOptions = [
  { value: 'card', text: 'Card' },
  { value: 'listicle', text: 'Listicle' },
  { value: 'infographic', text: 'Infographic' },
  { value: 'article', text: 'Article' },
  { value: 'video', text: 'Video' },
  { value: 'news', text: 'News' }
]



// WEBPACK FOOTER //
// ./src/config/constants.js